"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssetImage = void 0;
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var rarity_1 = require("@dcl/schemas/dist/dapps/rarity");
require("./AssetImage.css");
var AssetImage = function (props) {
    var name = props.name, rarity = props.rarity, src = props.src, className = props.className;
    var _a = rarity_1.Rarity.getGradient(rarity), light = _a[0], dark = _a[1];
    var backgroundImage = "radial-gradient(".concat(light, ", ").concat(dark, ")");
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)('AssetImage', className), style: {
            backgroundImage: backgroundImage
        } },
        react_1.default.createElement("img", { alt: name, className: "image", src: src })));
};
exports.AssetImage = AssetImage;
